import React, { memo, useMemo } from 'react'
import Svg from '../svg/svg'
import { PageActionButtonProps } from './types'
import Button from './button'

import * as styles from './pageActionButton.module.scss'

const PageActionButton = ({
   type,
   onClick,
   disabled,
   label,
   title,
}: PageActionButtonProps) => {
   const className = useMemo(() => {
      switch (type) {
         case 'add':
            return styles.addButton
         case 'import':
            return styles.importButton
         case 'excel-export':
         default:
            return styles.exportButton
      }
   }, [type])

   return (
      <Button
         preserveText
         variant="plain"
         minWidth="0"
         className={className}
         onClick={onClick}
         disabled={disabled}
         title={title}
      >
         <Svg id={type} /> {label}
      </Button>
   )
}

export default memo(PageActionButton)
